import { combineReducers } from 'redux'
import requestReducer from './components/video/requestReducer';

const rootReducer = combineReducers({
    requests: requestReducer,
})

export default rootReducer;